import { BLOCK_INTEGRATION, type BlockIntegrationData } from '@gitbook/doc-core';
import type { Block } from '@gitbook/slate';

import type { GastToHastTransformMap } from './types';
import { createCustomBlock } from './utils';

/**
 * Convert an integration block into HTML nodes.
 */
export const transformBlocksIntegration: GastToHastTransformMap<Block> = {
    [BLOCK_INTEGRATION]: async (node) => {
        const data = node.data.toFrozenObject() as BlockIntegrationData;

        return [
            createCustomBlock(
                `@${data.integration}/${data.block}`,
                {
                    ...data.props,
                    ...(typeof data.fullWidth !== 'undefined'
                        ? { fullWidth: `${Boolean(data.fullWidth)}` }
                        : undefined),
                },
                []
            ),
        ];
    },
};
